module.exports = __webpack_public_path__ + "static/media/RobotoMono-Medium.0eaa3f45.ttf";